<template>
        <div class="shop">
            <img class="shop__banner" :src="bannerImage"/>
            <shop-header :heading="$t('SHOP_HEADING')" :subheading="$t('SHOP_SUBHEADING')"/>
            <div class="shop__desktop">
                <div class="shop__filter-column">
                    <filters
                        class="shop__filters"
                        :title="$t('FILTER_TITLE')"
                        :categories="categories"
                        @input="filterProducts"/>
                </div>
                <div class="shop__product-column">
                    <menu-bar
                        @input="filterProducts"/>
                    <div class="shop__product-container">
                        <div class='shop__product-block' v-for="(item, key) in products" :key="key">
                            <product-card :item="item" @product-clicked="productClicked" v-if="displayProduct(item)" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import { CSPageEvents } from '@/helpers/GAHelpers';
import Filters from '@/components/partials/account/shop/Filters';
import MenuBar from '@/components/partials/account/shop/MenuBar';
import ShopHeader from '@/components/partials/account/shop/ShopHeader';
import ProductCard from '@/components/partials/account/shop/ProductCard';

export default {
    name: 'Shop',
    components: { MenuBar, ProductCard, ShopHeader, Filters },
    computed: {
        ...mapGetters({
            products: 'shop/getProducts',
            categories: 'shop/getCategories',
        }),
        bannerImage() {
            const isMobile = this.window.width < this.window.mobileBreakpoint;
            const deviceSrc = isMobile ? 'mobile' : 'desktop';
            const imageUrl = `https://freddiesflowers-com.s3.eu-west-2.amazonaws.com/images/shop/banner/${deviceSrc}.jpg`;
            return imageUrl;
        },
    },
    created() {
        this.$store.dispatch('shop/fetchProducts', { active_in: 'shop' });
        this.$store.dispatch('scheduledOrder/fetchAllDeliveries', true);
    },
    data() {
        return {
            window: {
                width: 0,
                mobileBreakpoint: 768,
            },
        };
    },
    methods: {
        ...mapGetters({
            allowsAnalytics: 'cookies/getAllowsAnalytics',
        }),
        ...mapActions({
            updateFilteredProducts: 'shop/updateFilteredProducts',
        }),
        ...mapMutations({
            clearFilteredProducts: 'shop/clearFilteredProducts',
        }),
        filterProducts(filter) {
            if (!filter.length) {
                this.clearFilteredProducts();
            } else {
                this.updateFilteredProducts(filter);
            }
        },
        handleResize() {
            this.window.width = window.innerWidth;
        },
        productClicked(item) {
            if (this.allowsAnalytics) {
                CSPageEvents(undefined, {
                    productId: item.productId,
                    productName: item.title,
                    productCategory: item.category,
                    productType: 'shopProduct',
                    frequency: 'once',
                });
            }
        },
        displayProduct(item) {
            return ![this.$t('XMAS_WREATH'), this.$t('XMAS_WREATH_17TH')].includes(item.title);
        },
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
};
</script>
